<template>
   <el-dialog title="汇总明细查询" :visible.sync="dialogVisible" width="60%" top="2vh" :modal-append-to-body="false" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="true" @opened="handleOpened"
              @close="handleClose">
      <div class="summary-detail-container">
         <!-- 汇总数据表格 -->
         <div class="summary-section">
            <div class="section-title">
               <span>汇总数据</span>
            </div>
            <!-- 查询条件 -->
            <div class="query-section">
               <el-form :inline="true" size="small">
                  <el-form-item label="零售单号:">
                     <el-input v-model="queryForm.retailId" placeholder="请输入零售单号" clearable style="width: 200px;" @keyup.enter.native="handleQuery" />
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="handleQuery" :loading="summaryLoading">查询</el-button>
                  </el-form-item>
               </el-form>
            </div>
            <el-table ref="summaryTable" :data="summaryData" :loading="summaryLoading" border stripe size="small" height="250" highlight-current-row @current-change="handleSummaryRowChange"
                      @row-click="handleSummaryRowClick" @keydown.native="handleKeyDown" tabindex="0" :row-class-name="getSummaryRowClassName">

               <el-table-column prop="retailId" label="零售单号" width="200" align="center" />
               <el-table-column prop="cashierName" label="收银员" width="200" align="center" />
               <el-table-column prop="retailType" label="单据类型" min-width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span>{{ scope.row.retailType == 1 ? '销售' : scope.row.retailType == 2 ? '退货' : '卤药' }}</span>
                  </template>
               </el-table-column>
               <el-table-column prop="recMoney" label="总金额" width="120" align="right">
                  <template slot-scope="scope">
                     <span style="color: #f56c6c; font-weight: bold;">
                        ¥{{ (scope.row.recMoney || 0).toFixed(2) }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column prop="totalNumber" label="总数量" width="100" align="center" />
               <el-table-column prop="createTime" label="创建时间" width="160" align="center">
                  <template slot-scope="scope">
                     {{ formatDateTime(scope.row.createTime) }}
                  </template>
               </el-table-column>
            </el-table>
         </div>

         <!-- 分割线 -->
         <el-divider>明细数据</el-divider>

         <!-- 明细数据表格 -->
         <div class="detail-section">
            <div class="section-title">
               <span>明细数据</span>
           
            </div>
            <el-table ref="detailTable" :data="detailData" :loading="detailLoading" border stripe size="small" height="150" empty-text="请先选择汇总数据">
               <el-table-column type="index" label="序号" width="60" align="center" />
               <el-table-column prop="bgmName" label="通用名称" width="120" align="center" />
               <el-table-column prop="spec" label="规格" min-width="150" show-overflow-tooltip />
               <el-table-column prop="batchno" label="批次" min-width="150" show-overflow-tooltip />
               <el-table-column prop="retailPrice" label="零售价" width="120" align="right">

               </el-table-column>
               <el-table-column prop="retailPnumber" label="销售数量" width="100" align="center" />
               <!-- <el-table-column prop="refundNum" label="退款数量" width="100" align="center" /> -->
               <el-table-column prop="psmoney" label="实付金额" width="120" align="right">
               </el-table-column>

            </el-table>
         </div>
      </div>

      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
         <el-button type="primary" @click="handleExport" :loading="exportLoading">
            复印小票
         </el-button>
      </span>
        <printPlan ref="printPlan"></printPlan>
   </el-dialog>
</template>

<script>
export default {
   name: 'SummaryDetailDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      // 可以传入额外的查询参数
      queryParams: {
         type: Object,
         default: () => ({})
      },
   },
   data() {
      return {
         // 汇总数据
         summaryData: [],
         summaryLoading: false,

         // 明细数据
         detailData: [],
         detailLoading: false,

         // 当前选中的汇总行
         selectedSummary: null,

         // 导出加载状态
         exportLoading: false,
         retailId: "",//明细id
         selectedSummaryIndex: -1, // 当前选中的汇总行索引
         isKeyboardNavigation: false, // 标识是否正在进行键盘导航
         
         // 查询表单
         queryForm: {
            retailId: '' // 零售单号查询条件
         }
      };
   },
   computed: {
      dialogVisible: {
         get() {
            return this.visible;
         },
         set(value) {
            this.$emit('update:visible', value);
         }
      }
   },
   watch: {
      visible(newVal) {
         if (newVal) {
            this.initData();
         } else {
            this.resetData();
         }
      }
   },
   methods: {
      // 初始化数据
      async initData() {
         await this.loadSummaryData();
      },

      // 重置数据
      resetData() {
         this.summaryData = [];
         this.detailData = [];
         this.selectedSummary = null;
         this.selectedSummaryIndex = -1;
         this.isKeyboardNavigation = false;
         this.queryForm.retailId = '';
      },

      // 加载汇总数据
      async loadSummaryData() {
         this.summaryLoading = true;
         try {
            // 构建查询参数
            const params = {
               storeId: this.queryParams.storeId,
               deskId: this.queryParams.deskId,
               //   start: this.queryParams.startDate,
               //   end: this.queryParams.endDate,
               page: 1,
               rows: 10
            };
            
            // 如果有零售单号查询条件，添加到参数中
            if (this.queryForm.retailId && this.queryForm.retailId.trim()) {
               params.retailId = this.queryForm.retailId.trim();
            }
            
            // 调用收银台汇总数据接口
            const response = await this.$http.retailQueryNear(params);

            if (response.status === 200) {
               this.summaryData = response.result.list || [];
               // 默认选中第一行
               if (this.summaryData.length > 0) {
                  this.selectedSummaryIndex = 0;
                  this.$nextTick(() => {
                     this.$refs.summaryTable.setCurrentRow(this.summaryData[0]);
                     this.selectedSummary = this.summaryData[0];
                     this.retailId = this.summaryData[0].retailId;
                     this.loadDetailData(this.summaryData[0].retailId);
                  });
               }
            } else {
               this.$message.error('获取汇总数据失败：' + response.message);
               this.summaryData = [];
            }
         } catch (error) {
            console.error('加载汇总数据失败:', error);
            this.$message.error('获取汇总数据失败');
            this.summaryData = [];
         } finally {
            this.summaryLoading = false;
         }
      },

      // 加载明细数据
      async loadDetailData(summaryId) {
         if (!summaryId) return;

         this.detailLoading = true;
         try {
            // 调用收银台明细数据接口
            const response = await this.$http.retailGetDetailPrintById({
               ids: [summaryId]
            });

            if (response.status === 200) {
               this.detailData = response.result || [];
            } else {
               this.$message.error('获取明细数据失败：' + response.message);
               this.detailData = [];
            }
         } catch (error) {
            console.error('加载明细数据失败:', error);
            this.$message.error('获取明细数据失败');
            this.detailData = [];
         } finally {
            this.detailLoading = false;
         }
      },

      // 汇总表格行选中变化
      handleSummaryRowChange(currentRow) {
         console.log('handleSummaryRowChange called, isKeyboardNavigation:', this.isKeyboardNavigation, 'currentRow:', currentRow);
         // 如果正在进行键盘导航，跳过处理
         if (this.isKeyboardNavigation) {
            console.log('Skipping handleSummaryRowChange due to keyboard navigation');
            return;
         }
         
         this.selectedSummary = currentRow;
         if (currentRow) {
            // 更新选中索引
            const index = this.summaryData.findIndex(item => item.retailId === currentRow.retailId);
            if (index !== -1) {
               this.selectedSummaryIndex = index;
            }
            this.retailId = currentRow.retailId;
            this.loadDetailData(currentRow.retailId);
         } else {
            this.detailData = [];
            this.retailId = "";
            this.selectedSummaryIndex = -1;
         }
      },

      // 汇总表格行点击
      handleSummaryRowClick(row) {
         // 找到点击行的索引
         const index = this.summaryData.findIndex(item => item === row);
         if (index !== -1) {
            this.selectedSummaryIndex = index;
            // 设置Element UI的当前行高亮
            if (this.$refs.summaryTable) {
               this.$refs.summaryTable.setCurrentRow(row);
            }
            // 滚动到选中行
            this.$nextTick(() => {
               this.scrollToSelectedSummary();
            });
         }
      },

      // 刷新汇总数据
      async refreshSummaryData() {
         await this.loadSummaryData();
         // 如果有选中的行，重新选中
         if (this.selectedSummary) {
            const foundRow = this.summaryData.find(item => item.id === this.selectedSummary.id);
            if (foundRow) {
               this.$nextTick(() => {
                  this.$refs.summaryTable.setCurrentRow(foundRow);
               });
            } else {
               this.selectedSummary = null;
               this.detailData = [];
            }
         }
      },

      // 导出数据
      async handleExport() {
         this.$http
            .retailOrderPrint({
               id: this.retailId,
               isPrint: 1,
            })
            .then((res) => {
               if (res.status === 200) {
                  console.log(res.result, "res.result");

                  //  // 打印方法
                  this.$printSocketApi.previewReport(
                     res.result,
                     this.queryParams.skPrint,
                     "print",
                     "",
                     0, //打印次数
                     this.retailId
                  );
               }
            });


      },

      // 格式化日期时间
      formatDateTime(dateTime) {
         if (!dateTime) return '';
         const date = new Date(dateTime);
         return date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
         });
      },

      // 格式化日期
      formatDate(date) {
         return date.toISOString().split('T')[0];
      },

      // 弹窗打开事件
      handleOpened() {
         this.selectedSummaryIndex = 0; // 默认选中第一行
         
         this.$nextTick(() => {
            // 聚焦到表格
            if (this.$refs.summaryTable) {
               this.$refs.summaryTable.$el.focus();
               
               // 设置Element UI的当前行高亮
               if (this.summaryData.length > 0) {
                  this.$refs.summaryTable.setCurrentRow(this.summaryData[0]);
               }
            }
            // 滚动到选中行
            this.scrollToSelectedSummary();
         });
         
         this.$emit('opened');
      },

      // 弹窗关闭事件
      handleClose() {
         this.dialogVisible = false;
         this.$emit('close');
      },

      // 键盘事件处理
      handleKeyDown(event) {
         if (!this.dialogVisible) return;
         if (this.summaryData.length === 0) return;

         if (event.key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            
            console.log('ArrowUp pressed, current index:', this.selectedSummaryIndex);
            
            // 设置键盘导航标识
            this.isKeyboardNavigation = true;
            
            if (this.selectedSummaryIndex > 0) {
               this.selectedSummaryIndex--;
            } else {
               this.selectedSummaryIndex = this.summaryData.length - 1;
            }
            
            console.log('New index after ArrowUp:', this.selectedSummaryIndex);

            // 滚动到选中行并更新数据
            this.$nextTick(() => {
               this.scrollToSelectedSummary();
               this.updateSelectedSummary();
               // 重置键盘导航标识
               this.isKeyboardNavigation = false;
            });
         } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            
            console.log('ArrowDown pressed, current index:', this.selectedSummaryIndex);
            
            // 设置键盘导航标识
            this.isKeyboardNavigation = true;
            
            if (this.selectedSummaryIndex < this.summaryData.length - 1) {
               this.selectedSummaryIndex++;
            } else {
               this.selectedSummaryIndex = 0;
            }
            
            console.log('New index after ArrowDown:', this.selectedSummaryIndex);

            // 滚动到选中行并更新数据
            this.$nextTick(() => {
               this.scrollToSelectedSummary();
               this.updateSelectedSummary();
               // 重置键盘导航标识
               this.isKeyboardNavigation = false;
            });
         } else if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            // Enter键可以触发复印小票
            this.handleExport();
         } else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.handleClose();
         }
      },

      // 更新选中的汇总数据
      updateSelectedSummary() {
         console.log('updateSelectedSummary called, index:', this.selectedSummaryIndex, 'data length:', this.summaryData.length);
         if (this.selectedSummaryIndex >= 0 && this.selectedSummaryIndex < this.summaryData.length) {
            const selectedRow = this.summaryData[this.selectedSummaryIndex];
            console.log('Selected row:', selectedRow);
            this.selectedSummary = selectedRow;
            this.retailId = selectedRow.retailId;
            this.loadDetailData(selectedRow.retailId);
            
            // 设置Element UI的当前行高亮
            if (this.$refs.summaryTable) {
               this.$refs.summaryTable.setCurrentRow(selectedRow);
            }
         }
      },

      // 滚动到选中的汇总行
      scrollToSelectedSummary() {
         this.$nextTick(() => {
            // 查找汇总明细弹窗中的表格
            const summaryTable = document.querySelector('.el-dialog__wrapper:not([style*="display: none"]) .el-table');
            if (!summaryTable) return;
            const tableBody = summaryTable.querySelector('.el-table__body-wrapper');
            if (tableBody && this.selectedSummaryIndex >= 0) {
               const rows = tableBody.querySelectorAll('.el-table__row');
               if (rows[this.selectedSummaryIndex]) {
                  // 计算目标行的位置
                  const targetRow = rows[this.selectedSummaryIndex];
                  const containerHeight = tableBody.clientHeight;
                  const rowTop = targetRow.offsetTop;
                  const rowHeight = targetRow.offsetHeight;
                  // 计算滚动位置，确保选中行在可视区域中间
                  const scrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2);
                  tableBody.scrollTo({
                     top: Math.max(0, scrollTop),
                     behavior: 'smooth'
                  });
               }
            }
         });
      },

      // 获取汇总行的class名称
      getSummaryRowClassName({ row, rowIndex }) {
         return rowIndex === this.selectedSummaryIndex ? 'selected-summary-row' : '';
      },
      
      // 查询按钮点击事件
      handleQuery() {
         this.loadSummaryData();
      },
      
 
   }
};
</script>

<style scoped>
.summary-detail-container {
   height: 600px;
   display: flex;
   flex-direction: column;
}

.summary-section {
   flex: 0 0 auto;
}

.detail-section {
   flex: 1;
   min-height: 0;
}

.section-title {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 10px;
   font-weight: bold;
   color: #303133;
}

.selected-info {
   font-size: 12px;
   color: #909399;
   font-weight: normal;
}

.query-section {
   margin-bottom: 15px;
   padding: 10px;

   border-radius: 4px;
}

.query-section .el-form {
   margin-bottom: 0;
}
::v-deep .el-form .el-form-item label{
   color: #000 !important;
}
.query-section .el-form-item {
   margin-bottom: 0;
}

.el-divider {
   margin: 15px 0;
}

/* 汇总表格选中行的样式 */
::v-deep .selected-summary-row {
   background-color: #ffdb12 !important;
}

::v-deep .selected-summary-row td {
   background-color: #ffdb12 !important;
}

/* 确保Element UI的当前行高亮样式不会被覆盖 */
::v-deep .el-table__row.current-row td {
   background-color: #ffdb12 !important;
}

/* 表格样式优化 */
::v-deep .el-table .current-row > td {
   background-color: #ecf5ff !important;
}

::v-deep .el-table .current-row:hover > td {
   background-color: #d9ecff !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
   .summary-detail-container {
      height: 500px;
   }

   .section-title {
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
   }
}
</style>
